import { validateReminderValue } from '../reminder-form/reminder-form.utils'

import { IChecklistReminderValues } from './checklist-reminder-form-types'

export const validateChecklistReminderValue = (сhecklistReminderValues: IChecklistReminderValues) => {
  let errorObject: any = {
    reminder: undefined,
  }

  errorObject.reminder = validateReminderValue(сhecklistReminderValues)?.reminder

  return errorObject
}
